import {
  Alert,
  Alignment,
  Button,
  Classes,
  Dialog,
  FormGroup,
  NonIdealState,
} from "@blueprintjs/core";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { autorun, runInAction } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { IEmpresa, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { LogsStore } from "../../stores/logs/LogsStore";
import { formatCnpj } from "../../utils";
import {
  EmpresaSelect,
  filterEmpresa,
  renderEmpresa,
} from "../empresa/EmpresaSelect";
import { DateRangePicker } from "../utils/DateRangePicker";
import {
  BootstrapTable,
  SearchField,
  TableHeaderColumn,
} from "react-bootstrap-table";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import LoadingModal from "../loading/LoadingModal";

@observer
export default class LogsSistema extends React.Component<{}, {}> {

  obs = observable({
    importingEmpresa: false as boolean,
    selectedPeriod: [] as any,
    pagina: "" as string,
    selectedEmpresa: newEmpresa() as IEmpresa,
    date1: "" as string,
    date2: "" as string,
    date: [] as any,
  })

  async componentDidMount() {
    this.obs.selectedPeriod = AppStore.obs1.selectedPeriod;
    this.obs.selectedEmpresa = AppStore.obs1.selectedEmpresa;

    this.handleDateChange(this.obs.selectedPeriod);

    this.obs.pagina = LogsStore.getCategoriaLogNsu();

    autorun(async () => {

      if(this.obs.date1 == "Data inválida") return
      
      if(this.obs.date2 == "Data inválida") return

      if (this.obs.selectedEmpresa && this.obs.pagina == "WEB SERVICE DISTRIBUICAO NFE" && this.obs.selectedPeriod) {
        await LogsStore.filterLogWebServiceNsu(
          this.obs.selectedEmpresa.cnpj,
          this.obs.pagina,
          this.obs.date1,
          this.obs.date2,
        );
      } else if (
        this.obs.selectedEmpresa && this.obs.pagina == "WEB SERVICE CIENCIA" && this.obs.selectedPeriod) {
        await LogsStore.filterLogWebServiceCiencia(
          this.obs.selectedEmpresa.cnpj,
          this.obs.pagina,
          this.obs.date1,
          this.obs.date2,
        );
      } else if (
        this.obs.selectedEmpresa && this.obs.pagina == "MANIFESTAÇÃO DESTINATARIO ERROS") {
        await LogsStore.filterLogWebServiceCiencia(
          this.obs.selectedEmpresa.cnpj,
          this.obs.pagina,
          this.obs.date1,
          this.obs.date2,
        );
      }
    });
  }

  handlePageChange = (page: number) => {
    LogsStore.setCurrentPage(page);
  };

  handleFilterClick = async () => {
    if (this.obs.selectedEmpresa && this.obs.pagina == "WEB SERVICE DISTRIBUICAO NFE") {
      await LogsStore.filterLogWebServiceNsu(
        this.obs.selectedEmpresa.cnpj,
        this.obs.pagina,
        this.obs.date1,
        this.obs.date2,
      );
    } else if (this.obs.selectedEmpresa && this.obs.pagina == "WEB SERVICE CIENCIA") {
      await LogsStore.filterLogWebServiceCiencia(
        this.obs.selectedEmpresa.cnpj,
        this.obs.pagina,
        this.obs.date1,
        this.obs.date2,
      );
    } else if (
      this.obs.selectedEmpresa && this.obs.pagina == "MANIFESTAÇÃO DESTINATARIO ERROS"
    ) {
      await LogsStore.filterLogWebServiceCiencia(
        this.obs.selectedEmpresa.cnpj,
        this.obs.pagina,
        this.obs.date1,
        this.obs.date2,
      );
    }
  };

  refresh = () => {
    window.location.reload();
  };

  handlePagina = (e: any) => {
    var string = e.target.value;
    this.obs.pagina = string;
  };

  handleDateChange = (val: any) => {
    var string = val.toString();
    var array = string.split(",");

    this.obs.date1 = moment(array[0]).format("YYYY-MM-DD")
    this.obs.date2 = moment(array[1]).format("YYYY-MM-DD")
    this.obs.date = val

    this.obs.selectedPeriod = val;
  };

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar"
      />
    );
  };

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  renderData() {
    let rows = LogsStore.obs.logs_web_service?.map(log => {
      return (
        {
          id: log.id,
          erro: log.erro,
          chave: log.chave,
          data: moment(log.inserted_at).format("DD/MM/YY") + " às " +
            moment(log.inserted_at.split(".").slice(0, -1).join(".")).format("h:mm:ss a"),
        }
      );
    });

    let empresaText = this.obs.selectedEmpresa.razao_social != ""
      ? `${this.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectedEmpresa.cnpj)
      })`
      : "Selecione uma empresa";

    const options = {
      page: 1, // which page you want to show as default
      sizePerPageList: [{
        text: "20",
        value: 20,
      }, {
        text: "50",
        value: 50,
      }, {
        text: "100",
        value: 100,
      }], // you can change the dropdown list for size per page
      sizePerPage: 20, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 4, // the pagination bar size.
      prePage: "Ante", // Previous page button text
      nextPage: "Próxima", // Next page button text
      firstPage: "Início", // First page button text
      lastPage: "Última", // Last page button text
      paginationShowsTotal: this.renderShowsTotal, // Accept bool or function
      paginationPosition: "bottom", // default is bottom, top and both is all available
      // hideSizePerPage: true > You can hide the dropdown for sizePerPage
      // alwaysShowAllBtns: true // Always show next and previous button
      // withFirstAndLast: false > Hide the going to First and Last page button
      rowsPerPageText: "Resultados por Página:",
      rangeSeparatorText: "de",
      noRowsPerPage: false,
      selectAllRowsItem: false,
      selectAllRowsItemText: "Todas",
      sortIndicator: true,
      clearSearch: false,
      searchField: this.createCustomSearchField,
    };

    return (
      <>
        <Alert
          confirmButtonText="Fechar"
          isOpen={LogsStore.obs.modalViewLog}
          onConfirm={() => LogsStore.obs.modalViewLog = false}
          onClose={() => LogsStore.obs.modalViewLog = false}
          canOutsideClickCancel={true}
        >
          <h2 className="titleSEFAZ">Detalhes do Log</h2>

          <p>
            <b>Ação:</b> {LogsStore.obs.acao}
          </p>
          <p>
            <b>Dados:</b> {LogsStore.obs.dados}
          </p>
          <p>
            <b>Informações:</b> {LogsStore.obs.processos}
          </p>
          <p>
            <b>Data:</b>{" "}
            {moment(LogsStore.obs.data_log).subtract(3, "hours").format(
              "DD/MM/YYYY",
            )} às{" "}
            {moment(LogsStore.obs.data_log).subtract(3, "hours").format("HH:mm")}
          </p>
        </Alert>
        <LoadingModal open={LogsStore.obs.modalViewWait} onClose={() => LogsStore.obs.modalViewWait = false} title={"Coletando logs"} />
        <MDBRow>
          <MDBCol xl="4" lg="4" md="4" sm="4" xs="12">
              <FormGroup label="Empresa" className="empresaSelect">
                <EmpresaSelect
                  items={EmpresaStore.sortedEmpresas}
                  itemRenderer={renderEmpresa}
                  itemPredicate={filterEmpresa}
                  onItemSelect={(e: IEmpresa) => this.obs.selectedEmpresa = e}
                  inputProps={{ placeholder: "Filtrar uma empresa" }}
                >
                  <Button
                    text={empresaText}
                    rightIcon="double-caret-vertical"
                    alignText={Alignment.LEFT}
                  />
                </EmpresaSelect>
              </FormGroup>
          </MDBCol>
          <MDBCol xl="3" lg="3" md="3" sm="3" xs="12">
              <FormGroup label="Categoria" className="nz-horizontal-field">
                <select onChange={this.handlePagina} className="form-control">
                  <option
                    key="WEB SERVICE DISTRIBUICAO NFE"
                    value="WEB SERVICE DISTRIBUICAO NFE"
                  >
                    WEB SERVICE DISTRIBUIÇÃO NFE
                  </option>
                  <option key="WEB SERVICE CIENCIA" value="WEB SERVICE CIENCIA">
                    WEB SERVICE CIÊNCIA
                  </option>
                  <option
                    key="MANIFESTAÇÃO DESTINATARIO ERROS"
                    value="MANIFESTAÇÃO DESTINATARIO ERROS"
                  >
                    MANIFESTAÇÃO DESTINATARIO ERROS
                  </option>
                </select>
              </FormGroup>
          </MDBCol>
        </MDBRow>
        <MDBRow>

          <MDBCol xl="3" lg="3" md="3" sm="3" xs="12">
              <FormGroup label="Período" className="inputsPeriodoCalculos">
                <DateRangePicker
                  onChange={this.handleDateChange}
                  value={this.obs.selectedPeriod}
                />
              </FormGroup>
          </MDBCol>
          <MDBCol md="2">
            <MDBBtn
              className="btnDefault btnBuscarNfe mt25"
              onClick={this.handleFilterClick}
            >
              Buscar
            </MDBBtn>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="12" sm="12" xs="12">
            <BootstrapTable
              className="TableDefault"
              ref="table"
              data={rows}
              options={options}
              hover
              pagination
              search
              collumnStyle={"white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"}
            >
              <TableHeaderColumn dataField="id" isKey={true} hidden>
                #
              </TableHeaderColumn>
              <TableHeaderColumn dataField="erro">
                Mensagem Sefaz
              </TableHeaderColumn>
              {this.obs.pagina == "WEB SERVICE CIENCIA" &&
                (
                  <TableHeaderColumn dataField="chave">
                    Chave
                  </TableHeaderColumn>
                )}
              <TableHeaderColumn dataField="data">
                Data
              </TableHeaderColumn>
            </BootstrapTable>
          </MDBCol>
        </MDBRow>
      </>
    );
  }

  renderNonIdeal() {
    return (
      <div className="nz-non-ideal">
        <NonIdealState
          icon="box"
          title="Você não possui permissão para acessar essa página"
        />
      </div>
    );
  }

  renderNormal() {
    return (
      <>
        {this.renderData()}
      </>
    );
  }

  render() {
    let niveis_acesso = AppStore.obs1.usuario ? AppStore.obs1.usuario.niveis_acesso : [""];
    if (niveis_acesso.indexOf("l1") == -1) {
      return this.renderNonIdeal();
    } else {
      return this.renderNormal();
    }
  }
}
